import {Row, Spinner} from 'native-base';
import {IHStackProps} from 'native-base/lib/typescript/components/primitives/Stack/HStack';
import IcChevronRight from '@ui/svg/IcChevronRight';
import ParticipantAvatar from '@ui/components/participant/ParticipantAvatar';
import React from 'react';
import {TeamUiData} from '@shared/models/team';
import {TouchableOpacity} from 'react-native';
import {useTranslation} from 'react-i18next';

interface TeamItemProps {
    team: TeamUiData;
    onPress?: (team: TeamUiData) => void;
    isLoading?: boolean;
    _row?: IHStackProps;
}

const TeamItem = (props: TeamItemProps) => {
    const {team, onPress, isLoading = false, _row} = props;
    const {t} = useTranslation();

    return (
        <TouchableOpacity onPress={onPress && !isLoading ? () => onPress(team) : undefined}>
            <Row bg='white' overflow='hidden' rounded='lg' p='4' h='20' justifyContent='space-between' alignItems='center' {..._row}>
                <ParticipantAvatar
                    participant={team}
                    direction='row'
                    _avatar={{size: 'md'}}
                    space='4'
                    w={undefined}
                    _text={{variant: 'mediumSemiBold'}}
                    subtitle={team.totalParticipants ? t('auth.team.playersAmount', {playersAmount: team.totalParticipants}) : undefined}
                />

                {isLoading ?
                    <Spinner color='black' /> :
                    <IcChevronRight /> }
            </Row>
        </TouchableOpacity>
    );
};

export default TeamItem;
